module.exports = __webpack_public_path__ + "img/ProductPage-bundelImage.4023ee30.jpg";